import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { mapStateToProps, mapDispatchToProps } from '../../utils';
import { Theme } from '../../config/theme';

import { logout } from '../../actions/user';
import { getBlogPost } from '../../actions/applicationData';
import { updateAppState } from '../../actions/applicationState';

import Body from '../../components/Body';
import Footer from '../../components/Footer';
import DashboardHeader from '../../components/DashboardHeader';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';
import YouTubeEmbed from '../../components/YouTubeEmbed';

class BlogPost extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
  }

  componentWillMount() {
    const slug = this.props.match.params.slug;
    this.fetchBlogPost(slug);
  }

  getContent() {
    return {
      '__html': this.state.post.content,  // eslint-disable-line
    };
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  fetchBlogPost(slug) {
    this.props.dispatch(updateAppState({
      loading: true,
    })).then(() => {
      this.props.dispatch(
        getBlogPost(slug),
      ).then((response) => {
        this.setState({
          post: response,
          loaded: true,
        });

        this.props.dispatch(updateAppState({
          loading: false,
        }));
      }, (err) => {
        console.log(err); // eslint-disable-line no-console
        this.props.dispatch(updateAppState({
          loading: false,
        }));
        this.props.history.push('/404');
      });
    });
  }

  render() {
    const dynamicStyles = StyleSheet.create({
      banner: {
        backgroundImage: this.state.post ? `url('${this.state.post.hero_url}')` : 'none',
      },
    });

    /* eslint-disable react/no-danger */
    return (
      <Body hasFooter>
        {
          this.props.user.isAuthenticated ? (
            <DashboardHeader
              logoutHandler={this.logoutHandler}
              redirectHandler={this.redirectHandler}
              {...this.props} />
          ) : (
            <UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />
          )
        }
        <div className={css(styles.page_container)}>
          <div className={css(styles.banner, dynamicStyles.banner)}>
            <div className={css(styles.banner_container)}>
              <h1 className={css(styles.banner_title)}>
                {this.state.post ? this.state.post.title : false}
              </h1>
            </div>
          </div>

          {
            this.state.post ? (
              <div className={css(styles.content)}>
                <div
                  className={css(styles.container)}
                  dangerouslySetInnerHTML={this.getContent()} />

                {
                  this.state.post && this.state.post.video ? (
                    <YouTubeEmbed vid={this.state.post.video.id} />
                  ) : false
                }
              </div>
            ) : false
          }
        </div>
        <Footer user={this.props.user} />
      </Body>
    );
    /* eslint-enable react/no-danger */
  }
}

BlogPost.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  page_container: {
    backgroundColor: Theme.white,
  },
  container: {
    padding: '80px 15px 20px',
    backgroundColor: Theme.white,

    [Theme.mobile_query]: {
      paddingBottom: 15,
    },

    ':not(.a) p': {
      marginBottom: 15,
      fontFamily: Theme.font_family_primary,
      fontSize: 16,
      lineHeight: 1.72,
      textAlign: 'left',
      color: '#000e1f',

      [Theme.mobile_query]: {
        padding: '0 20px',
        fontSize: 15,
      },
    },

    ':not(.a) div': {
      marginBottom: 15,
      fontFamily: Theme.font_family_primary,
      fontSize: 16,
      lineHeight: 1.72,
      textAlign: 'left',
      color: '#000e1f',

      [Theme.mobile_query]: {
        padding: '0 20px',
        fontSize: 15,
      },
    },
    ':not(.a) h1': {
      margin: '25px 0px',
      fontSize: 28,
      fontWeight: 'bold',
    },
    ':not(.a) h2': {
      margin: '25px 0px',
      fontSize: 25,
      fontWeight: 'bold',
    },
    ':not(.a) h3': {
      margin: '25px 0px',
      fontSize: 22,
      fontWeight: 'bold',
    },
    ':not(.a) strong': {
      fontWeight: 'bold',
    },
    ':not(.a) .photocredit': {
      fontWeight: 'bold',
      marginTop: -20,
      fontSize: 14,
    },
    ':not(.a) .photocaption': {
      padding: 0,
    },
    ':not(.a) small': {
      margin: '25px 0px',
      fontSize: 14,
      fontWeight: 'bold',
    },
    ':not(.a) em': {
      margin: '25px 0px',
      fontStyle: 'italic',
    },
    ':not(.a) img': {
      margin: '25px 0px',
    },
  },
  content: {
    paddingBottom: Theme.footer.height / 2,
    maxWidth: 750,
    margin: '0 auto 20px',
  },
  title: {
    marginBottom: 24,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'left',
  },
  banner_container: {
    width: Theme.container_width,
    margin: '0 auto',
  },
  banner: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 400,
    marginTop: 80,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: '0 0 0 1000px rgba(0,0,0,.3) inset',

    [Theme.mobile_query]: {
      height: 'auto',
      padding: '80px 20px',
      backgroundPosition: 'left center',
    },
  },
  banner_title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 64,
    fontWeight: Theme.font_weight_heading,
    color: Theme.white,
    textAlign: 'center',

    [Theme.mobile_query]: {
      fontSize: 45,
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BlogPost);



// WEBPACK FOOTER //
// ./src/views/BlogPost/index.js